define('root/Assets/Templates/Html/Menu/Js/Module/MenuToggleHandler',[
	'jquery',
	'project/MbiConfig',
	'base/MbiHelper',
	'base/WildcardClass'
], function(
	$,
	mbiConfig,
	_
) {
	'use strict';

	// ---------------------------------------------------------------
	// MENU TOGGLE HANDLER
	//
	// simple toggles a menu, using one or more buttons.
	// the buttons also receive an active class and are connected to the navigation state.
	// a click outside the navigation also closes it.
	// ---------------------------------------------------------------

	var module = {

		$body:					$('body'),
		buttonsSelector: 		'.js_toggle-overlay',
		navigationSelector: 	'.js_overlay',
		menuClass: 				'has_overlay--open',
		stickyClass: 			'has_sticky--open',
		buttonActiveClass: 		'is_active',
		buttonLockedClass: 		'is_locked',
		overlayClosingClass: 	'is_closing',
		overlayAttr:			'data-overlay-open',

		$buttons:				undefined,
		clickerSelector:		undefined,

		close: function(transition) {

			if(typeof transition == 'undefined') {
				transition = true;
			} else {
				transition = false;
			}

			var $overlay = $(module.navigationSelector);

			var theClass = module.$body.attr(module.overlayAttr);

			if(transition) {

				$overlay.addClass(module.overlayClosingClass);

			}
			module.$body.removeClass('has_*--open').attr(module.overlayAttr, '');
			module.$buttons.removeClass(module.buttonActiveClass + ' ' + module.buttonLockedClass);
			$(document).off('click', module.clickTrick); // remove click handler when clicked once

			$(document).trigger('menuToggleHandlerClosing', { class : theClass });

			if(!Modernizr.csstransitions) {
				$overlay.removeClass(module.overlayClosingClass);
				$(document).trigger('menuToggleHandlerClosed', { class : theClass });
			}

		},
		clickTrick: function(e) {

			if($(e.target).closest(module.clickerSelector).length === 0 ) { // "it's magic"

				e.preventDefault();
				module.close();

			}

		},
		init: function() {
			
			module.$buttons = 			$(module.buttonsSelector);
			module.clickerSelector = 	module.navigationSelector+', '+module.buttonsSelector + ', .js_clickSelector';

			module.$buttons.attr('tabindex', '0'); // it's a accessibility thing

			$(document).on('click', module.buttonsSelector, function(e) {
				
				e.preventDefault();

				var $this = $(this),
					$thisButtons = $(module.buttonsSelector + '[data-overlay-target="' + $this.attr('data-overlay-target') + '"]');

				if(!$this.hasClass(module.buttonLockedClass)) {

					module.$buttons.addClass(module.buttonLockedClass);

					var toggleClass = $this.attr('data-overlay-toggle-class'),
						currentClass = $('body').attr(module.overlayAttr);
					// var toggleTargetSelector = $this.attr('data-overlay-target');

					if(!module.$body.hasClass(module.menuClass) && !module.$body.hasClass(module.stickyClass)) { // if nav closed

						module.$body.addClass(module.menuClass + ' ' + toggleClass).attr(module.overlayAttr, toggleClass); // open nav

						$thisButtons.addClass(module.buttonActiveClass);

						$(document).on('click', module.clickTrick); // add click outside nav to close

						$(document).trigger('menuToggleHandlerOpen', { class : toggleClass });

					} else if(module.$body.hasClass(module.menuClass) && toggleClass !== currentClass)   {

						module.close();

						module.$body.addClass(module.menuClass + ' ' + toggleClass).attr(module.overlayAttr, toggleClass); // open nav

						$thisButtons.addClass(module.buttonActiveClass);

						$(document).on('click', module.clickTrick); // add click outside nav to close

						$(document).trigger('menuToggleHandlerOpen', { class : toggleClass });

					} else {

						module.close();

					}

					module.$buttons.removeClass(module.buttonLockedClass);

				}

			});

			var $overlay = $(module.navigationSelector);

			if(Modernizr.csstransitions) {

				$(document).on(_.transitionend(), module.navigationSelector, function(e) {
					e.stopPropagation();
									
						$overlay.each(function() {

							var $this = $(this);
							if (typeof $this.attr('data-overlay-transition-property') !== 'undefined') {

								var transitionProperty = Modernizr.prefixed($this.attr('data-overlay-transition-property'));

								if($this.hasClass(module.overlayClosingClass) && e.originalEvent.propertyName == transitionProperty) {

									$this.removeClass(module.overlayClosingClass);

									var theClass = module.$body.attr(module.overlayAttr);

									$(document).trigger('menuToggleHandlerClosed', { class : theClass });

								}
							}

						});
					

				});

			}

		}

	};

	module.init();

	mbiConfig.modules.MenuToggleHandler = true;

	return module;

});
